import "core-js/modules/es.function.name";
import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";

var _hoisted_1 = /*#__PURE__*/_createVNode("hr", null, null, -1);

var _hoisted_2 = {
  class: "level"
};
var _hoisted_3 = {
  class: "level-item has-text-centered"
};
var _hoisted_4 = {
  class: "image is-64x64"
};
var _hoisted_5 = {
  class: "level-item has-text-centered"
};

var _hoisted_6 = /*#__PURE__*/_createVNode("p", {
  class: "heading"
}, "Repos", -1);

var _hoisted_7 = {
  class: "title"
};
var _hoisted_8 = {
  class: "level-item has-text-centered"
};

var _hoisted_9 = /*#__PURE__*/_createVNode("p", {
  class: "heading"
}, "Gists", -1);

var _hoisted_10 = {
  class: "title"
};
var _hoisted_11 = {
  class: "level-item has-text-centered"
};
var _hoisted_12 = {
  class: "heading"
};
var _hoisted_13 = {
  class: "title"
};
var _hoisted_14 = {
  class: "level-item has-text-centered"
};
var _hoisted_15 = {
  class: "heading"
};
var _hoisted_16 = {
  class: "title"
};

var _hoisted_17 = /*#__PURE__*/_createVNode("hr", null, null, -1);

var _hoisted_18 = {
  class: "icon"
};
var _hoisted_19 = {
  class: "content"
};
var _hoisted_20 = {
  key: 0,
  class: "has-text-grey-light"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createBlock(_Fragment, null, [_createVNode("h3", {
    class: "subtitle is-4",
    alt: _ctx.locale
  }, _toDisplayString(_ctx.t("message.components.githubActivity.stats")), 9, ["alt"]), _hoisted_1, _createVNode("div", _hoisted_2, [_createVNode("div", _hoisted_3, [_createVNode("figure", _hoisted_4, [_createVNode("img", {
    class: "is-rounded",
    src: _ctx.user.avatar_url,
    alt: _ctx.user.name + ' - ' + _ctx.user.location
  }, null, 8, ["src", "alt"])])]), _createVNode("div", _hoisted_5, [_createVNode("div", null, [_hoisted_6, _createVNode("p", _hoisted_7, _toDisplayString(_ctx.user.public_repos), 1)])]), _createVNode("div", _hoisted_8, [_createVNode("div", null, [_hoisted_9, _createVNode("p", _hoisted_10, _toDisplayString(_ctx.user.public_gists), 1)])]), _createVNode("div", _hoisted_11, [_createVNode("div", null, [_createVNode("p", _hoisted_12, _toDisplayString(_ctx.t("message.components.githubActivity.followers")), 1), _createVNode("p", _hoisted_13, _toDisplayString(_ctx.user.followers), 1)])]), _createVNode("div", _hoisted_14, [_createVNode("div", null, [_createVNode("p", _hoisted_15, _toDisplayString(_ctx.t("message.components.githubActivity.following")), 1), _createVNode("p", _hoisted_16, _toDisplayString(_ctx.user.following), 1)])])]), (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.events, function (event) {
    return _openBlock(), _createBlock("div", {
      class: "is-size-6",
      key: event.id
    }, [_hoisted_17, _createVNode("span", _hoisted_18, [_createVNode("i", {
      class: 'fas fa-' + event.iconType
    }, null, 2)]), _createVNode("span", _hoisted_19, [_createVNode("span", {
      innerHTML: event.sentence
    }, null, 8, ["innerHTML"]), event.created_at ? (_openBlock(), _createBlock("span", _hoisted_20, "  " + _toDisplayString(_ctx.fromNow(event.created_at)), 1)) : _createCommentVNode("", true)])]);
  }), 128
  /* KEYED_FRAGMENT */
  ))], 64
  /* STABLE_FRAGMENT */
  );
}